import {} from "react";
import { useApp } from "@/state/app-context";
import { useLongPress } from "./use-long-press";
/**
 * Long-press → enter stack-multiselect mode (with this stack seeded).
 *
 * Mirrors `useLongPressCollectionSelect` but populates the parallel
 * `stackSelection` set, which the action bar reads to surface the
 * "Unstack" affordance. No tap path here — the stack tile's
 * `onClick` branches between toggle-unfurl and toggle-selection
 * based on the current multiselect mode.
 *
 * No-op while any multiselect mode is already active — clicking the
 * card from inside an active multiselect is the toggle path.
 *
 * Pass `undefined` to disable the long-press entirely — used by
 * synthetic stacks (visual-only same-collection day groupings on the
 * homepage Stream) which have no server identity and shouldn't be
 * seedable into the selection set.
 */
export function useLongPressStackSelect(stackId, cardRef) {
    const app = useApp();
    useLongPress(cardRef, {
        haptic: "medium",
        onLongPress: () => {
            if (stackId === undefined)
                return;
            if (app.state.ui.isMultiselectMode)
                return;
            app.enterStackMultiselectMode(stackId);
        },
    });
}
